import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/user-menu/user-menu.js';
      import {ObcUserMenuType, ObcUserMenuSize, ObcUserMenuUser, ObcUserMenuSignedInAction} from '@oicl/openbridge-webcomponents/dist/components/user-menu/user-menu.js';

      export interface Props {
     type?: ObcUserMenuType;
     size?: ObcUserMenuSize;
     hasRecentlySignedIn?: boolean;
     username?: string;
     password?: string;
     usernameError?: string;
     passwordError?: string;
     userInitials?: string | undefined;
     userLabel?: string | undefined;
     recentUsers?: ObcUserMenuUser[];
     signedInActions?: ObcUserMenuSignedInAction[]
   }

      
  
      export type {ObcUserMenuType, ObcUserMenuSize, ObcUserMenuUser, ObcUserMenuSignedInAction} from '@oicl/openbridge-webcomponents/dist/components/user-menu/user-menu.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcUserMenu',
  props: {
    type: {},
    size: {},
    hasRecentlySignedIn: { type: Boolean },
    username: {},
    password: {},
    usernameError: {},
    passwordError: {},
    userInitials: {},
    userLabel: {},
    recentUsers: {},
    signedInActions: {}
  },
  emits: ["sign-in-click", "sign-out-click", "signed-in-action-click", "recent-user-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onSignInClick: (event: CustomEvent<{username: string, password: string}>) => emit('sign-in-click', event as CustomEvent<{username: string, password: string}>),
onSignOutClick: (event: CustomEvent<unknown>) => emit('sign-out-click', event as CustomEvent<unknown>),
onSignedInActionClick: (event: CustomEvent<{id: string, label: string}>) => emit('signed-in-action-click', event as CustomEvent<{id: string, label: string}>),
onRecentUserClick: (event: CustomEvent<{initials: string, label: string}>) => emit('recent-user-click', event as CustomEvent<{initials: string, label: string}>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-user-menu',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})